import { FC, useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { icons } from "../../icons/IconSet";
import Input from "../form/Input";

export interface IUserSearchValue {
  email: string,
  name: string,
}

const UserSearch: FC<{
  email: string,
  name: string,
  onChange: (next: IUserSearchValue) => void,
}> = ({ email, name, onChange }) => {
  const [localEmail, setLocalEmail] = useState<string>(() => email);
  const [localName, setLocalName] = useState<string>(() => name);

  const [debouncedEmail] = useDebounce(localEmail, 400);
  const [debouncedName] = useDebounce(localName, 400);

  // -- Keep inputs in sync when the parent resets the filter (e.g. Clear)
  useEffect(() => setLocalEmail(() => email), [email]);
  useEffect(() => setLocalName(() => name), [name]);

  // -- Push debounced values up only when they actually differ
  useEffect(() => {
    if (debouncedEmail !== email || debouncedName !== name) {
      onChange({ email: debouncedEmail, name: debouncedName });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedEmail, debouncedName]);

  const hasValue = !!localEmail || !!localName;

  return (
    <div className="flex items-end gap-3 flex-wrap">
      <Input
        size="small"
        name="searchEmail"
        label="Search by email"
        placeholder="Email"
        value={localEmail}
        handle={(e) => setLocalEmail(() => e?.target?.value || '')}
        className="w-[220px]"
      />
      <Input
        size="small"
        name="searchName"
        label="Search by name"
        placeholder="Name"
        value={localName}
        handle={(e) => setLocalName(() => e?.target?.value || '')}
        className="w-[220px]"
      />
      {hasValue && (
        <button
          type="button"
          className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-800 transition-colors h-[36px]"
          onClick={() => {
            setLocalEmail(() => '');
            setLocalName(() => '');
          }}
        >
          {icons('x', { width: '16px' })}
          Clear
        </button>
      )}
    </div>
  );
};

export default UserSearch;
